/*
 * Intelligent Fabric — collapsed sidebar logo (woven-fabric mark).
 * Mirrors the brand-mark SVG from the approved Admin Console sketch.
 */
const LogoIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="if-mark" x1="0" y1="0" x2="48" y2="48">
          <stop offset="0" stopColor="#21e0c4" />
          <stop offset="0.55" stopColor="#5b8df7" />
          <stop offset="1" stopColor="#8b7bf7" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="44" height="44" rx="12" fill="#0e1222" stroke="url(#if-mark)" strokeWidth="1.5" />
      <path d="M11 17 L37 17 M11 24 L37 24 M11 31 L37 31" stroke="url(#if-mark)" strokeWidth="2.4" strokeLinecap="round" opacity="0.55" />
      <path d="M17 11 L17 37 M24 11 L24 37 M31 11 L31 37" stroke="url(#if-mark)" strokeWidth="2.4" strokeLinecap="round" />
      <circle cx="24" cy="24" r="3.4" fill="url(#if-mark)" />
    </svg>
  );
};

export default LogoIcon;
